module.exports = __webpack_public_path__ + "static/media/lawberry-logo_on_black.eadde47d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lawberry-logo_on_black.svg
// module id = 2842
// module chunks = 0